import { PackingSlipDetailDto } from "./packing-slip-detail-dto.model";

export class PackingSlipDto {
  orderId = 0;
  email = '';
  packingSlipDetailDtos: PackingSlipDetailDto[] = [];
  shipDate: Date | undefined;
}
